import { createFileRoute } from '@tanstack/react-router';
import { CampaignClaimSuccess } from '@/pages';

export const Route = createFileRoute('/_authenticated/campaign/$id/accepted')({
  component: CampaignClaimSuccess,
});
